import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription, tap } from 'rxjs';
import { ConfigResourceService } from '@mri/app/resources';
import { ConfigMeasurementUnit, FieldOption } from '@mri/types';
import { ChoiceTypes } from '@mri/enums';

@Component({
  selector: 'app-alarm-field-speeding',
  templateUrl: './alarm-field-speeding.component.html',
  styleUrl: './alarm-field-speeding.component.scss'
})
export class AlarmFieldSpeedingComponent implements OnInit {
  private _subscription = new Subscription();
  private _units: ConfigMeasurementUnit[];
  private _value: number;
  private _prevUnitKey: string;

  currentUnitKey: string;

  options: FieldOption[] = [];

  get optionUnitKey(){
    return this.currentUnitKey || this.unitDefault;
  }
  get value(){
    const unit = this._units?.find(u => u.key === this.optionUnitKey);

    return parseInt((this._value * (unit?.multiply || 1)).toFixed(0));
  }

  @Input()
  set value(value: number) {
    if(value === this._value) return;

    this._value = value;
  }

  @Input()
  set unit(value: string) {
    if(value === this.currentUnitKey) return;

    this.currentUnitKey = value;
  }

  @Input()
  unitDefault?: string;

  @Output()
  valueChange = new EventEmitter<number>();

  @Output()
  unitChange = new EventEmitter<string>();

  constructor(
    private _configSrv: ConfigResourceService
  ) {
  }


  ngOnInit(): void {
    this._subscription.add(
      this._configSrv.getUnits$()
        .pipe(
          tap(units => {
            this._units = units.filter(u => u.type === ChoiceTypes.SPEED);

            this.options = this._configSrv.getOptions(ChoiceTypes.SPEED);
          })
        )
        .subscribe()
    );
  }

  onChangeValue(value: number){
    const unit = this._units?.find(u => u.key === this.optionUnitKey);

    const realValue = value / (unit?.multiply || 1);
    this._value = realValue;
    this.valueChange.emit(realValue);
  }


  onChangeUnit(unit: string) {
    this._prevUnitKey = this.currentUnitKey;
    this.currentUnitKey = unit;
    this.unitChange.emit(unit);

  }
}
